/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

// React rejects a string `style`, so the Figma export's `mask-type:luminance`
// is written as a style object and held here rather than rebuilt per render,
// as the other masked icons in this library do ...
const maskStyle = {maskType: 'luminance'} as React.CSSProperties;

/*
 * Defines the Design Language System (DLS) Battery Low Status Icon component.
 */
export const BatteryLowStatusIcon = ({color = dlsColor('black')}: IconProps) => {
  const {iconColor} = useIconDLS({color});
  
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_23373_19363)'>
        <mask id='mask0_23373_19363' style={maskStyle} maskUnits='userSpaceOnUse' x='5' y='3' width='6' height='10'>
          <path d='M10.5997 3.33398H5.33301V12.134H10.5997V3.33398Z' fill='white'/>
        </mask>
        <g mask='url(#mask0_23373_19363)'>
          <path d='M8.39967 8.60066H7.53301V6.00065H8.39967V8.60066ZM8.39967 10.4007H7.53301V9.534H8.39967V10.4007ZM10.0663 4.20065H9.33301V3.33398H6.66634V4.20065H5.93301C5.59967 4.20065 5.33301 4.46732 5.33301 4.80065V11.534C5.33301 11.8673 5.59967 12.134 5.93301 12.134H9.99967C10.333 12.134 10.5997 11.8673 10.5997 11.534V4.80065C10.5997 4.46732 10.333 4.20065 10.0663 4.20065Z' fill={iconColor}/>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_23373_19363'>
          <rect width='16' height='16' fill='white'/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default BatteryLowStatusIcon;
